import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';
import getAccountShipmentV2, {
  type V2ShipmentDetail,
} from '../getAccountShipmentV2';

export type PostAccountShipmentPublishVariables = {
  accountId: number;
  shipmentId: number;
};

/**
 * POST `/api/v2/accounts/{account}/shipments/{shipment}/published` — Draft → Not Started.
 */
export default function usePostAccountShipmentPublish() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      shipmentId,
    }: PostAccountShipmentPublishVariables) => {
      const { api, baseURL } = getApi();
      const res = await api.post(
        `/api/v2/accounts/${accountId}/shipments/${shipmentId}/published`,
        {},
        { baseURL },
      );
      return (res.data?.data ?? res.data) as V2ShipmentDetail;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['account-shipments'] });
      queryClient.invalidateQueries({
        queryKey: getAccountShipmentV2.queryKey(
          variables.accountId,
          variables.shipmentId,
        ),
      });
    },
  });
}
